import { createContext, useState } from "react";
import { getProductData } from "./productStore";
import { useNavigate } from "react-router-dom";

export const CartContext = createContext({
  items: [],
  getProductQuantity: () => {},
  addOneToCart: () => {},
  removeOneFromCart: () => {},
  deleteFromCart: () => {},
  getTotalCost: () => {},
  token: "",
  localID: (id) => {},
  isLoggedIn: false,
  login: (token) => {},
  logout: () => {},
});

export function CartProvider({ children }) {
  const navigate = useNavigate();

  const initialToken = localStorage.getItem("token");

  const [token, setToken] = useState(initialToken);
  const [cartProducts, setCartProduct] = useState([]);

  const userIsLoggedIn = !!token;

  const logoutHandler = () => {
    setToken(null);
    navigate("/register");
    localStorage.removeItem("token");
  };

  const localID = (id) => {
    return id;
  };

  const loginHandler = (token) => {
    setToken(token);
    localStorage.setItem("token", token);
  };

  function getProductQuantity(id) {
    const quantity = cartProducts.find(
      (product) => product.id === id
    )?.quantity;

    if (quantity === undefined) {
      return 0;
    }

    return quantity;
  }

  function addOneToCart(id) {
    const quantity = getProductQuantity(id);
    const store = getProductData(id);

    if (quantity === 0) {
      setCartProduct([
        ...cartProducts,
        {
          id: id,
          quantity: 1,
          name: store.name,
          price: store.price,
          image: store.image,
        },
      ]);
    } else {
      setCartProduct(
        cartProducts.map((product) =>
          product.id === id
            ? {
                ...product,
                quantity: product.quantity + 1,
                name: store.name,
                price: store.price,
                image: store.image,
              }
            : product
        )
      );
    }
  }

  function removeOneFromCart(id) {
    const quantity = getProductQuantity(id);

    if (quantity === 1) {
      deleteFromCart(id);
    } else {
      setCartProduct(
        cartProducts.map((product) =>
          product.id === id
            ? { ...product, quantity: product.quantity - 1 }
            : product
        )
      );
    }
  }

  function deleteFromCart(id) {
    setCartProduct((cartProducts) =>
      cartProducts.filter((curProduct) => {
        return curProduct.id !== id;
      })
    );
  }

  function getTotalCost() {
    let totalCost = 0;
    cartProducts.map((cartItem) => {
      const productData = getProductData(cartItem.id);
      totalCost += productData.price * cartItem.quantity;
    });

    return totalCost;
  }

  const contextValue = {
    items: cartProducts,
    token: token,
    isLoggedIn: userIsLoggedIn,
    localID: localID,
    login: loginHandler,
    logout: logoutHandler,
    getProductQuantity,
    addOneToCart,
    removeOneFromCart,
    deleteFromCart,
    getTotalCost,
  };

  return (
    <CartContext.Provider value={contextValue}>{children}</CartContext.Provider>
  );
}

export default CartProvider;
